export type Json =
  | string
  | number
  | boolean
  | null
  | { [key: string]: Json | undefined }
  | Json[]

export type Database = {
  public: {
    Tables: {
      constants: {
        Row: {
          created_at: string | null
          id: string
          name: string
          updated_at: string | null
          value: string
        }
        Insert: {
          created_at?: string | null
          id?: string
          name: string
          updated_at?: string | null
          value: string
        }
        Update: {
          created_at?: string | null
          id?: string
          name?: string
          updated_at?: string | null
          value?: string
        }
        Relationships: []
      }
      minute_packages: {
        Row: {
          created_at: string
          currency: string | null
          description: string | null
          id: string
          is_active: boolean
          is_popular: boolean | null
          minutes_amount: number
          price: number
          sort_order: number | null
          title: string | null
          title_key: string | null
          updated_at: string | null
        }
        Insert: {
          created_at?: string
          currency?: string | null
          description?: string | null
          id?: string
          is_active?: boolean
          is_popular?: boolean | null
          minutes_amount: number
          price: number
          sort_order?: number | null
          title?: string | null
          title_key?: string | null
          updated_at?: string | null
        }
        Update: {
          created_at?: string
          currency?: string | null
          description?: string | null
          id?: string
          is_active?: boolean
          is_popular?: boolean | null
          minutes_amount?: number
          price?: number
          sort_order?: number | null
          title?: string | null
          title_key?: string | null
          updated_at?: string | null
        }
        Relationships: []
      }
      profiles: {
        Row: {
          balance: number
          created_at: string | null
          id: string
          updated_at: string | null
          telegram_id: number | null
          lead_form_completed: boolean | null
          lead_form_dismissed: boolean | null
          is_admin: boolean | null
          telegram_first_name: string | null
          telegram_last_name: string | null
          telegram_username: string | null
          telegram_updated_at: string | null
          funnel_stage_id: string | null
          notification_settings: Json | null
          yandex_client_id: number | null
          tracking_params: Json | null
          api_key: string
          webhook_url: string | null
          webhook_secret: string
          webhook_enabled: boolean | null
          user_settings: Json | null
          lang: string | null
          currency: string | null
        }
        Insert: {
          balance?: number
          created_at?: string | null
          id: string
          updated_at?: string | null
          telegram_id?: number | null
          lead_form_completed?: boolean | null
          lead_form_dismissed?: boolean | null
          is_admin?: boolean | null
          telegram_first_name?: string | null
          telegram_last_name?: string | null
          telegram_username?: string | null
          telegram_updated_at?: string | null
          funnel_stage_id?: string | null
          notification_settings?: Json | null
          yandex_client_id?: number | null
          tracking_params?: Json | null
          api_key?: string
          webhook_url?: string | null
          webhook_secret?: string
          webhook_enabled?: boolean | null
          user_settings?: Json | null
          lang?: string | null
          currency?: string | null
        }
        Update: {
          balance?: number
          created_at?: string | null
          id?: string
          updated_at?: string | null
          telegram_id?: number | null
          lead_form_completed?: boolean | null
          lead_form_dismissed?: boolean | null
          is_admin?: boolean | null
          telegram_first_name?: string | null
          telegram_last_name?: string | null
          telegram_username?: string | null
          telegram_updated_at?: string | null
          funnel_stage_id?: string | null
          notification_settings?: Json | null
          yandex_client_id?: number | null
          tracking_params?: Json | null
          api_key?: string
          webhook_url?: string | null
          webhook_secret?: string
          webhook_enabled?: boolean | null
          user_settings?: Json | null
          lang?: string | null
          currency?: string | null
        }
        Relationships: []
      }
      record_tags: {
        Row: {
          id: string
          record_id: string
          tag_id: string
          created_at: string
        }
        Insert: {
          id?: string
          record_id: string
          tag_id: string
          created_at?: string
        }
        Update: {
          id?: string
          record_id?: string
          tag_id?: string
          created_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "record_tags_record_id_fkey"
            columns: ["record_id"]
            isOneToOne: false
            referencedRelation: "records"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "record_tags_tag_id_fkey"
            columns: ["tag_id"]
            isOneToOne: false
            referencedRelation: "tags"
            referencedColumns: ["id"]
          },
        ]
      }
      records: {
        Row: {
          created_at: string
          duration: unknown
          file_path: string
          id: string
          metadata: Json | null
          name: string
          post_processing_text: string | null
          processing_finished_at: string | null
          processing_results: Json | null
          processing_started_at: string | null
          processing_status:
          | Database["public"]["Enums"]["processing_status"]
          | null
          processing_status_desc: string | null
          processing_time: unknown | null
          status: string
          template_id: string | null
          transcript_text: string | null
          user_id: string
        }
        Insert: {
          created_at?: string
          duration: unknown
          file_path: string
          id?: string
          metadata?: Json | null
          name: string
          post_processing_text?: string | null
          processing_finished_at?: string | null
          processing_results?: Json | null
          processing_started_at?: string | null
          processing_status?:
          | Database["public"]["Enums"]["processing_status"]
          | null
          processing_status_desc?: string | null
          processing_time?: unknown | null
          status: string
          template_id?: string | null
          transcript_text?: string | null
          user_id: string
        }
        Update: {
          created_at?: string
          duration?: unknown
          file_path?: string
          id?: string
          metadata?: Json | null
          name?: string
          post_processing_text?: string | null
          processing_finished_at?: string | null
          processing_results?: Json | null
          processing_started_at?: string | null
          processing_status?:
          | Database["public"]["Enums"]["processing_status"]
          | null
          processing_status_desc?: string | null
          processing_time?: unknown | null
          status?: string
          template_id?: string | null
          transcript_text?: string | null
          user_id?: string
        }
        Relationships: [
          {
            foreignKeyName: "records_template_id_fkey"
            columns: ["template_id"]
            isOneToOne: false
            referencedRelation: "templates"
            referencedColumns: ["id"]
          },
        ]
      }
      tags: {
        Row: {
          id: string
          name: string
          color: string
          user_id: string
          created_at: string
          deleted_at: string | null
          sort_order: number
        }
        Insert: {
          id?: string
          name: string
          color?: string
          user_id: string
          created_at?: string
          deleted_at?: string | null
          sort_order?: number
        }
        Update: {
          id?: string
          name?: string
          color?: string
          user_id?: string
          created_at?: string
          deleted_at?: string | null
          sort_order?: number
        }
        Relationships: [
          {
            foreignKeyName: "tags_user_id_fkey"
            columns: ["user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      templates: {
        Row: {
          created_at: string
          deleted_at: string | null
          description: string
          id: string
          is_system: boolean | null
          name: string
          order_code: number | null
          preview_template_result: string | null
          prompt: string
          user_id: string | null
          lang: string | null
        }
        Insert: {
          created_at?: string
          deleted_at?: string | null
          description: string
          id?: string
          is_system?: boolean | null
          name: string
          order_code?: number | null
          preview_template_result?: string | null
          prompt: string
          user_id?: string | null
          lang?: string | null
        }
        Update: {
          created_at?: string
          deleted_at?: string | null
          description?: string
          id?: string
          is_system?: boolean | null
          name?: string
          order_code?: number | null
          preview_template_result?: string | null
          prompt?: string
          user_id?: string | null
          lang?: string | null
        }
        Relationships: []
      }
      transactions: {
        Row: {
          amount: number
          comment: string | null
          created_at: string | null
          id: string
          package_id: string | null
          payment_id: string | null
          payment_status: string
          record_id: string | null
          type: Database["public"]["Enums"]["transaction_type"]
          user_id: string
          withdrawal_status:
          | Database["public"]["Enums"]["withdrawal_status"]
          | null
        }
        Insert: {
          amount: number
          comment?: string | null
          created_at?: string | null
          id?: string
          package_id?: string | null
          payment_id?: string | null
          payment_status?: string
          record_id?: string | null
          type: Database["public"]["Enums"]["transaction_type"]
          user_id: string
          withdrawal_status?:
          | Database["public"]["Enums"]["withdrawal_status"]
          | null
        }
        Update: {
          amount?: number
          comment?: string | null
          created_at?: string | null
          id?: string
          package_id?: string | null
          payment_id?: string | null
          payment_status?: string
          record_id?: string | null
          type?: Database["public"]["Enums"]["transaction_type"]
          user_id?: string
          withdrawal_status?:
          | Database["public"]["Enums"]["withdrawal_status"]
          | null
        }
        Relationships: [
          {
            foreignKeyName: "transactions_package_id_fkey"
            columns: ["package_id"]
            isOneToOne: false
            referencedRelation: "minute_packages"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "transactions_record_id_fkey"
            columns: ["record_id"]
            isOneToOne: false
            referencedRelation: "records"
            referencedColumns: ["id"]
          },
        ]
      }
      shared_links: {
        Row: {
          id: string
          record_id: string
          user_id: string
          token: string
          expires_at: string | null
          is_active: boolean
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          record_id: string
          user_id: string
          token: string
          expires_at?: string | null
          is_active?: boolean
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          record_id?: string
          user_id?: string
          token?: string
          expires_at?: string | null
          is_active?: boolean
          created_at?: string
          updated_at?: string
        }
        Relationships: [
          {
            foreignKeyName: "shared_links_record_id_fkey"
            columns: ["record_id"]
            isOneToOne: false
            referencedRelation: "records"
            referencedColumns: ["id"]
          },
          {
            foreignKeyName: "shared_links_user_id_fkey"
            columns: ["user_id"]
            isOneToOne: false
            referencedRelation: "profiles"
            referencedColumns: ["id"]
          },
        ]
      }
      share_analytics: {
        Row: {
          id: string
          shared_link_id: string
          viewed_at: string
          viewer_ip: string | null
          user_agent: string | null
          session_duration: string | null
        }
        Insert: {
          id?: string
          shared_link_id: string
          viewed_at?: string
          viewer_ip?: string | null
          user_agent?: string | null
          session_duration?: string | null
        }
        Update: {
          id?: string
          shared_link_id?: string
          viewed_at?: string
          viewer_ip?: string | null
          user_agent?: string | null
          session_duration?: string | null
        }
        Relationships: [
          {
            foreignKeyName: "share_analytics_shared_link_id_fkey"
            columns: ["shared_link_id"]
            isOneToOne: false
            referencedRelation: "shared_links"
            referencedColumns: ["id"]
          },
        ]
      }
    }
    Views: {
      [_ in never]: never
    }
    Functions: {
      create_record: {
        Args: { name: string; template_id: string; file_path: string; p_metadata?: Json }
        Returns: {
          created_at: string
          duration: unknown
          file_path: string
          id: string
          metadata: Json | null
          name: string
          post_processing_text: string | null
          processing_finished_at: string | null
          processing_results: Json | null
          processing_started_at: string | null
          processing_status:
          | Database["public"]["Enums"]["processing_status"]
          | null
          processing_status_desc: string | null
          processing_time: unknown | null
          status: string
          template_id: string | null
          transcript_text: string | null
          user_id: string
        }
      }
      get_and_lock_tasks: {
        Args: { p_worker_id: string; p_batch_size: number }
        Returns: unknown[]
      }
      get_constant_value: {
        Args: { constant_name: string }
        Returns: string
      }
      process_successful_payment: {
        Args: {
          tx_id: string
          user_uuid: string
          pkg_id: string
          yookassa_payment_id: string
        }
        Returns: undefined
      }
      update_processing_task: {
        Args: { p_task_id: string; p_data: Json }
        Returns: boolean
      }
      create_shared_link: {
        Args: { p_record_id: string; p_expires_at?: string | null }
        Returns: {
          id: string
          token: string
          expires_at: string | null
          created_at: string
        }[]
      }
      get_shared_record: {
        Args: { p_token: string }
        Returns: {
          id: string
          name: string
          duration: unknown
          created_at: string
          transcript_text: string | null
          post_processing_text: string | null
          shared_link_id: string
        }[]
      }
      record_share_view: {
        Args: {
          p_shared_link_id: string
          p_viewer_ip?: string | null
          p_user_agent?: string | null
        }
        Returns: string
      }
      deactivate_shared_link: {
        Args: { p_shared_link_id: string }
        Returns: boolean
      }
      reactivate_shared_link: {
        Args: { p_shared_link_id: string }
        Returns: boolean
      }
      update_profile_lang: {
        Args: { new_lang: string }
        Returns: string
      }
      update_profile_currency: {
        Args: { new_currency: string }
        Returns: string
      }
      get_my_visitor_id: {
        Args: Record<string, never>
        Returns: string
      }
    }
    Enums: {
      processing_status:
      | "waiting"
      | "queued"
      | "processing"
      | "completed"
      | "failed"
      | "cancelled"
      transaction_type: "deposit" | "withdrawal" | "bonus"
      withdrawal_status: "frozen" | "completed" | "cancelled"
    }
    CompositeTypes: {
      [_ in never]: never
    }
  }
}

type DefaultSchema = Database[Extract<keyof Database, "public">]

export type Tables<
  DefaultSchemaTableNameOrOptions extends
  | keyof (DefaultSchema["Tables"] & DefaultSchema["Views"])
  | { schema: keyof Database },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof Database
  }
  ? keyof (Database[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
    Database[DefaultSchemaTableNameOrOptions["schema"]]["Views"])
  : never = never,
> = DefaultSchemaTableNameOrOptions extends { schema: keyof Database }
  ? (Database[DefaultSchemaTableNameOrOptions["schema"]]["Tables"] &
    Database[DefaultSchemaTableNameOrOptions["schema"]]["Views"])[TableName] extends {
      Row: infer R
    }
  ? R
  : never
  : DefaultSchemaTableNameOrOptions extends keyof (DefaultSchema["Tables"] &
    DefaultSchema["Views"])
  ? (DefaultSchema["Tables"] &
    DefaultSchema["Views"])[DefaultSchemaTableNameOrOptions] extends {
      Row: infer R
    }
  ? R
  : never
  : never

export type TablesInsert<
  DefaultSchemaTableNameOrOptions extends
  | keyof DefaultSchema["Tables"]
  | { schema: keyof Database },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof Database
  }
  ? keyof Database[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
  : never = never,
> = DefaultSchemaTableNameOrOptions extends { schema: keyof Database }
  ? Database[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
    Insert: infer I
  }
  ? I
  : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
  ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
    Insert: infer I
  }
  ? I
  : never
  : never

export type TablesUpdate<
  DefaultSchemaTableNameOrOptions extends
  | keyof DefaultSchema["Tables"]
  | { schema: keyof Database },
  TableName extends DefaultSchemaTableNameOrOptions extends {
    schema: keyof Database
  }
  ? keyof Database[DefaultSchemaTableNameOrOptions["schema"]]["Tables"]
  : never = never,
> = DefaultSchemaTableNameOrOptions extends { schema: keyof Database }
  ? Database[DefaultSchemaTableNameOrOptions["schema"]]["Tables"][TableName] extends {
    Update: infer U
  }
  ? U
  : never
  : DefaultSchemaTableNameOrOptions extends keyof DefaultSchema["Tables"]
  ? DefaultSchema["Tables"][DefaultSchemaTableNameOrOptions] extends {
    Update: infer U
  }
  ? U
  : never
  : never

export type Enums<
  DefaultSchemaEnumNameOrOptions extends
  | keyof DefaultSchema["Enums"]
  | { schema: keyof Database },
  EnumName extends DefaultSchemaEnumNameOrOptions extends {
    schema: keyof Database
  }
  ? keyof Database[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"]
  : never = never,
> = DefaultSchemaEnumNameOrOptions extends { schema: keyof Database }
  ? Database[DefaultSchemaEnumNameOrOptions["schema"]]["Enums"][EnumName]
  : DefaultSchemaEnumNameOrOptions extends keyof DefaultSchema["Enums"]
  ? DefaultSchema["Enums"][DefaultSchemaEnumNameOrOptions]
  : never

export type CompositeTypes<
  PublicCompositeTypeNameOrOptions extends
  | keyof DefaultSchema["CompositeTypes"]
  | { schema: keyof Database },
  CompositeTypeName extends PublicCompositeTypeNameOrOptions extends {
    schema: keyof Database
  }
  ? keyof Database[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"]
  : never = never,
> = PublicCompositeTypeNameOrOptions extends { schema: keyof Database }
  ? Database[PublicCompositeTypeNameOrOptions["schema"]]["CompositeTypes"][CompositeTypeName]
  : PublicCompositeTypeNameOrOptions extends keyof DefaultSchema["CompositeTypes"]
  ? DefaultSchema["CompositeTypes"][PublicCompositeTypeNameOrOptions]
  : never

export const Constants = {
  public: {
    Enums: {
      processing_status: [
        "waiting",
        "queued",
        "processing",
        "completed",
        "failed",
        "cancelled",
      ],
      transaction_type: ["deposit", "withdrawal", "bonus"],
      withdrawal_status: ["frozen", "completed", "cancelled"],
    },
  },
} as const

// Custom types for tags system
export interface Tag {
  id: string;
  name: string;
  color: string;
  user_id: string;
  created_at: string;
  deleted_at: string | null;
  sort_order: number;
}

export interface RecordTag {
  id: string;
  record_id: string;
  tag_id: string;
  created_at: string;
}

export interface RecordWithTags extends Tables<"records"> {
  tags: Tag[];
}

// Tag colors for the application
export const TAG_COLORS = [
  '#EF4444', // Red
  '#F97316', // Orange  
  '#EAB308', // Yellow
  '#22C55E', // Green
  '#3B82F6', // Blue
  '#8B5CF6', // Purple
  '#EC4899', // Pink
] as const;

export type TagColor = typeof TAG_COLORS[number] | string; // Поддержка произвольных hex цветов

// Types for sharing functionality (using generated Supabase types)
export type SharedLink = Tables<"shared_links">;
export type ShareAnalytics = Tables<"share_analytics">;
export type SharedLinkInsert = TablesInsert<"shared_links">;
export type SharedLinkUpdate = TablesUpdate<"shared_links">;
export type ShareAnalyticsInsert = TablesInsert<"share_analytics">;

export interface SharedRecord {
  id: string;
  name: string;
  duration: unknown; // interval type
  created_at: string;
  transcript_text: string | null;
  post_processing_text: string | null;
  shared_link_id: string;
}

export interface SharedLinkWithAnalytics extends SharedLink {
  analytics: ShareAnalytics[];
  total_views: number;
}

